export const EmailAddressChangeRoutes = [
    {
        "url": "/settings",
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["email-address-change"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/email-address-change/email-address-change.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/:view?tab&section",
        "name": "appLayout.harriSH.settings.section",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["email-address-change"]
        }
    },
    {
        "url": "/edit/profile/:view",
        "name": "appLayout.harriSH.editprofile",
        "type": "frontend",
        "route_styles": {
            styles: ["email-address-change"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/email-address-change/email-address-change.downgrade.module");
                }
            },
        ]
    }
];
export const EmailAddressChangeTLRoutes = [
    {
        "url": "/settings",
        "name": "appLayout.schedule.settings",
        "type": "frontend",
        "loginRequired": true,
        "params": {},
        "route_styles": {
            styles: ["email-address-change"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/email-address-change/email-address-change.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=email-address-change.routes.js.map